import { Building } from "../external-sources/Buildings";
import { Floor } from "../external-sources/Floors";
import { Room } from "../external-sources/Rooms";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";

export const location: FieldSchema = {
  name: "location",
  grid: {
    displayed: true,
    order: 8,
  },
  data: {
    assignedValue: {
      getter: ({ buildingLocation, floor, room }) => buildingLocation && floor && room ?
        `${(buildingLocation as Building).buildingNumber};${(floor as Floor).floorCode};${(room as Room).roomCode}` :
        EMPTY_VALUE,
      fields: ["buildingLocation", "floor", "room"],
    },
  },
  dataTransform: {
    toDb: {
      getter: ({ buildingLocation, floor, room }) => buildingLocation && floor && room ?
        `${(buildingLocation as Building).buildingNumber};${(floor as Floor).floorCode};${(room as Room).roomCode}` :
        EMPTY_VALUE,
      fields: ["buildingLocation", "floor", "room"],
    },
  },
  validation: {
    // A location is the four parts together; a partial one would silently mix a new
    // building with a stored floor. The rule lives here rather than in a caller so the
    // form, bulk edit and the CSV import all apply it.
    custom: {
      getter: (values) => {
        const locationParts = [values.siteName, values.buildingLocation, values.floor, values.room];
        return locationParts.some(Boolean) && !locationParts.every(Boolean) ?
          "siteName, buildingLocation, floor and room must all be provided together" :
          EMPTY_VALUE;
      },
      fields: ["siteName", "buildingLocation", "floor", "room"],
    },
  },
  form: { label: "Location", disabled: true, displayed: false },
};
